import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitSummaryPage } from './init-summary';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitSummaryPage,
  ],
  imports: [
    IonicPageModule.forChild(InitSummaryPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitSummaryPageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-summary/init-summary.module.ts